import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class EventService {
  emitter: ReplaySubject<any> = new ReplaySubject(1);

  emitChangeEvent(data: any) {
    this.emitter.next(data);
  }
}
